import {useEffect, useState} from 'react';
import {getSubtenantById} from '../../../api/subtenantsApi';
import {getBlacklistedTenantIds} from '../utils';
type BlacklistInfo = {
	id: string;
	organisation: {
		name: string;
	};
};

const useBlacklistedTenants = (blacklistIds?: string[]) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [tenants, setTenants] = useState<BlacklistInfo[]>([]);
	useEffect(() => {
		const rawIds = blacklistIds ? blacklistIds : getBlacklistedTenantIds();
		const subtenantIds = Array.isArray(rawIds) ? rawIds : typeof rawIds === 'string' ? rawIds.split(',') : [];

		if (subtenantIds && subtenantIds.length) {
			setLoading(true);
			Promise.all(
				subtenantIds.map((subtenantId: string) => {
					return getSubtenantById(subtenantId)
						.then((subtenant) => ({
							id: subtenant.id,
							organisation: {
								name: subtenant.organisation.name
							}
						}))
						.catch(() => ({
							id: subtenantId,
							organisation: {
								name: subtenantId
							}
						}));
				})
			)
				.then((subtenants: BlacklistInfo[]) => {
					setTenants(subtenants);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [blacklistIds]);

	return {
		loading,
		tenants
	};
};

export default useBlacklistedTenants;
